import Sidebar from "./Sidebar";
import { Link, useParams } from "react-router-dom";
import ExportSidebar from "./ProSideBar";
import { PageHeader } from "./AuxiliaryFunctions";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import UserDataService from './services/user.serviceaux.js';
import { Button, Container, OverlayTrigger, Row, Table } from "react-bootstrap";
import { CiCircleCheck, CiCircleMinus } from "react-icons/ci";
import { AiFillCheckCircle } from "react-icons/ai";
import { MdCancel } from "react-icons/md";


const ListaCompleta = () => {
    const { user: currentUser } = useSelector((state) => state.auth);	
    let params = useParams();
    let compid = params.compid;
    const [lista, setLista] = useState();

    useEffect(() => {
        UserDataService.getListaCompleta(compid,0,"id","ASC")
        .then(resp => {
            console.log(resp.data);
            setLista(resp.data);
        })
        .catch(err => {
            console.log(err);
        });
    },[]);

    return (
        <>
        <Sidebar />
        <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
            <ExportSidebar roles={currentUser.roles}/>        
            <div style={{display:'block',width:'100%'}}>
                <PageHeader />        
                <div className="main-frame-page">
                    <h5 style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{"Lista completa de jueces"}</h5>
                    < hr/>
                    <Container>
                        <Row>
                            <Table style={{verticalAlign:"baseline"}} size="sm">
                                <TableHeader/>
                                <TableBody listOf={lista} />
                            </Table>
                        </Row>
                        <hr/>
                    </Container>                 
                </div>
            </div>
        </div>
        </>  
    );
};

const TableHeader = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  return (

    <thead>
      <tr>
        <th style={{width:'30%'}}>Juez</th>
        <th style={{width:'10%'}}>Disponibilidad?</th>
        <th style={{width:'10%'}}>Asignado?</th>
        <th>Area con mayor experiencia</th>
        <th>Area asignada</th>
      </tr>
    </thead>
  )
}


const TableBody = (props) => {  
    const { user: currentUser } = useSelector((state) => state.auth);	

    if (props.listOf) {    
        const rows = props.listOf.map((row, index) => {         
        return (      
            <>
            <tr key={index}>        
            <td className='d-none d-sm-table-cell'>
                {
                    (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim() + " " +
                    (row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                }
            </td>
            <td>
                {row.confirmacion_activa==1?<AiFillCheckCircle size={25} color="green"/>:<MdCancel size={26} color="red"/>}
            </td>            
            <td>
                {row.compid?<AiFillCheckCircle size={25} color="green"/>:<MdCancel size={26} color="red"/>}
            </td>
            <td>
                {((row.arean1experiencia || "") + " - " + (row.arean2experiencia || "")).trim()}
            </td>
            <td>  
                {row.nombrearea}
            </td>
            </tr>
            </>
        )
        })
        return (
        <tbody>
            {rows}
        </tbody>
        )  
    }
    else {
        return null;
    }
}




export default ListaCompleta;